export const setupEbooks = () => {
  const actionButtons = document.querySelectorAll(".action_btn");
  const ebookForm = document.getElementById("ebook-form");
  actionButtons.forEach((button) =>
    button.addEventListener("click", () => {
      console.log("asdd");
      ebookForm.scrollIntoView({
        behavior: "smooth",
      });
    })
  );
};
